const rollBackVersion2: string = '1.20230920.3.1';
const rollBackVersion1: string = '1.20230925.3.3';
const signOffVersion: string = '1.20231002.1.0';
const fixForwardVersion1: string = '1.20231002.1.1';
const fixForwardVersion2: string = '1.20231002.1.2';
const fixForwardVersion3: string = '1.20231002.1.3';

const rollBackVersion2KS: string = '9a8c0aa7-7b0c-4134-b620-0c825da1b3b2'; /*17/10/2023, KS for rollBackVersion2*/
const rollBackVersion1KS: string = 'd07e7f15-e887-4688-95e8-b22ced221543'; /*17/10/2023, KS for rollBackVersion1*/
const fixForwardVersion1KS: string = '0101787f-ca1c-4e22-b8e0-0b282284525c'; /*17/10/2023, KS for fixForwardVersion1*/
const fixForwardVersion2KS: string = '2f4bb05d-74dc-4df3-a9a4-72b3085d3f6c'; /*17/10/2023, KS for fixForwardVersion2*/
const fixForwardVersion3KS: string = 'e8b9d4fb-e15b-404c-8878-267c2e0137d7'; /*17/10/2023, KS for fixForwardVersion3*/

export default function getSerpVersion(
    microsoftSearchBootstrapperKillSwitchesActive: string
) {
    const searchBootstrapperKS = JSON.parse(microsoftSearchBootstrapperKillSwitchesActive) as Array<string>;

    if (searchBootstrapperKS && searchBootstrapperKS.length > 0) {
        if (searchBootstrapperKS.indexOf(rollBackVersion2KS) >= 0) {
           return rollBackVersion2;
        } else if (searchBootstrapperKS.indexOf(rollBackVersion1KS) >= 0) {
           return rollBackVersion1;
        } else if (searchBootstrapperKS.indexOf(fixForwardVersion1KS) >= 0) {
           return fixForwardVersion1;
        } else if (searchBootstrapperKS.indexOf(fixForwardVersion2KS) >= 0) {
           return fixForwardVersion2;
        } else if (searchBootstrapperKS.indexOf(fixForwardVersion3KS) >= 0) {
           return fixForwardVersion3;
        }
        return signOffVersion;
    }
    return signOffVersion;
}
